module.exports = __webpack_public_path__ + "img/manda_009.d35deb08.png";